import type { Matrix4 } from 'three'
import { Vector3 } from 'three'

/** 当前胶囊后端只支持可逆的相似变换（含反射），拒绝非均匀缩放与剪切。 */
export function validateCollisionTransform(matrix: Matrix4): void {
  const axes = [0, 1, 2].map((index) => new Vector3().setFromMatrixColumn(matrix, index))
  const lengths = axes.map((axis) => axis.length())
  const scale = Math.max(...lengths)
  if (
    !matrix.elements.every(Number.isFinite) ||
    scale <= 1e-8 ||
    lengths.some((value) => Math.abs(value - scale) > scale * 1e-6) ||
    Math.abs(axes[0].dot(axes[1])) > scale * scale * 1e-6 ||
    Math.abs(axes[0].dot(axes[2])) > scale * scale * 1e-6 ||
    Math.abs(axes[1].dot(axes[2])) > scale * scale * 1e-6
  )
    throw new Error('Tiles 碰撞后端不支持奇异、非均匀缩放或剪切变换；显示仍可使用')
}
